/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Save_PromptInputs */



/**
* | output |
* | --- |
* | "Enter a name for this standards preset." |
*
* @param {Standards_Preset_Save_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_save_prompt = /** @type {((inputs?: Standards_Preset_Save_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Save_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
	return /** @type {LocalizedString} */ ("Enter a name for this standards preset.")
});